import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';

import { Serie } from '../../../models/serie';
import { ParametroService } from '../../../services/parametro.service';

@Component({
  selector: 'app-serie-ingreso-modal',
  templateUrl: './serie-ingreso-modal.component.html',
  styleUrls: ['./serie-ingreso-modal.component.css'],
  providers: [ParametroService,]
})
export class SerieIngresoModalComponent implements OnInit, AfterViewInit {

  @Input() series: Array<Serie>;
  @Output() sendSeries = new EventEmitter<any>();
  public nombre_codigo: string = "";
  // public series: Array<Serie>;
  public codigo: string;
  // public serie: any;
  public loading: boolean;
  public found_code: string;
  @ViewChild('inputBarcode') searchElement: ElementRef;
  constructor(
    public bsModalRef: BsModalRef,
    private parametroService: ParametroService,
  ) {
    this.series = [];
    this.codigo = "";
    this.found_code = "";
    this.loading = false;
   }

  ngOnInit() {
    this.loading = true;
    this.getNombeCodigo().then(
      res => this.loading = false,
      err => this.loading = false,
    );
  }

  getNombeCodigo(){
    return new Promise ((resolve, reject) => {
      this.parametroService.getById(31).subscribe(
        res => {
          this.nombre_codigo = res.valor;
          resolve(true);
        },
        err => {
          reject();
        }
      )
    });
  }

  
  ngAfterViewInit(){
    this.setFocus();
  }

  setFocus(){
    setTimeout(() => {
      this.searchElement.nativeElement.focus();
    }, 500);
  }

  onSearchBarcode(event){
    let keycode = event.charCode;

    if( event.keyCode == 13 ){
      this.addSerie();
    }
  }

  addSerie(){
    if( this.codigo.length >= 1 && this.codigo.toString().trim() != '' ) {
      let serieExiste = this.series.filter(s => s.codigo.toString().trim() == this.codigo.toString().trim())[0];
      if(!serieExiste){
        let serie = new Serie();

        serie.codigo = this.codigo.toString().trim();
  
        this.series.push(serie);
      }else {
        this.found_code = this.codigo.toString().trim();
        setTimeout(() => {
          this.found_code = null;
        }, 2000);
       
      }
     
      
    }
    this.codigo = "";
  }

  onSubmit(){
    this.sendSeries.emit(this.series);
    this.bsModalRef.hide();
  }

  onDelete(i) {
		this.series.splice(i, 1);
	}

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/serie-ingreso-modal/serie-ingreso-modal.component.ts